import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {AppStoreType} from './bll/store'
import {loadingAC} from './bll/loadingReducer'
import SuperButton from '../hw04/common/c2-SuperButton/SuperButton'
import s2 from '../../s1-main/App.module.css';
import s10 from './Loader.module.css'
import {Loader} from './Loader'

/*
* 1 - в файле loadingReducer.ts дописать типы и логику
* 2 - получить isLoading из редакса
* 3 - дописать функцию setLoading
* 4 - сделать стили в соответствии с дизайном
* */

export const HW10 = () => {
    const dispatch = useDispatch()
  const isLoading = useSelector((state: AppStoreType) => state.loading.isLoading)
    // useSelector, useDispatch // пишет студент+

    const setLoading = () => { // пишет студент // показать крутилку на 1,5 секунд
        // dispatch +
   dispatch(loadingAC(true))
        // setTimeout
        setTimeout(() => {
            dispatch(loadingAC(false)) //выключаем загрузку через 1,5 секунды
        }, 1500)
        console.log(s2); // Выведет объект со всеми классами
        console.log(s2.hw); // Должно вывести строку, например, "App_hw__FZFw+"
    }

    return (
        <div id={'hw10'}>
            <div className={s2.hwTitle}>Homework #10</div>

            <div className={s2.hw + ' ' + s2.hw10} >
                {isLoading ? (
                    <div id={'hw10-loading'} >
                        <Loader/>
                    </div>
                ) : (
                    <SuperButton
                        id={'hw10-button-start-loading'}
                        onClick={setLoading}
                    >
                        Set loading...
                    </SuperButton>
                )}
            </div>
        </div>
    )
}

export default HW10
